import { css } from 'linaria';
import { contentBaseWrapper, imageBaseWrapper, productBaseWrapper } from './common-styles';
import { styled } from 'linaria/react';

export const productNameTextInWidget = css`
  display: block !important;
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: var(--space-900);
  overflow-wrap: anywhere;
`;

export const productNameWithoutReviews = css`
  -webkit-line-clamp: 3;
`;

export const productWrapper = productBaseWrapper;

export const imageWrapper = imageBaseWrapper;

export const pricesWrapper = css`
  margin-block: var(--space-100);
`;

export const productInfoWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  &.list {
    flex-direction: row;
    min-height: 200px;
  }

  &.large-card {
    flex-direction: column;
    height: 100%;
  }

  @media (--only-mobile) {
    &,
    &.large-card,
    &.list {
      flex-direction: column;
      height: 100%;
    }
  }
`;

export const contentWrapper = contentBaseWrapper;

export const secondaryPrice = css`
  position: relative;
`;

export const primaryPriceFractCurrencyWrap = css`
  display: inline-block;
  font-weight: 500;
  color: var(--text-primary);
`;

export const MarkerLayout = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
`;

export const brandShelfItemStyle = css`
  width: 152px;
  height: 292px;
  background-color: var(--background-primary);
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  box-sizing: content-box;

  @media (--to-tablet) {
    width: 139px;
    padding: 16px;
  }
`;

export const brandShelfProductName = css`
  color: var(--text-primary);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.12px;
`;
